import { getElement, toggleSpinnerAndContainer, scrollToElementWithOffset } from "../shared/pageComponents"; 

document.addEventListener('DOMContentLoaded', () => {
    toggleSpinnerAndContainer('embla-spinner', 'embla-container', 1000);
    initializeDOneFormHandling();
});

function initializeDOneFormHandling() {
    // Set date range for datepickers
    function setDateRange(formId, fieldId, startDate, endDate) {
        gform.addFilter('gform_datepicker_options_pre_init', function(optionsObj, fId, fFieldId) {
            if (fId === formId && fieldId === fFieldId) {
                const start = new Date(startDate);
                const end = new Date(endDate);
                const ranges = [{ start, end }];

                optionsObj.beforeShowDay = function(date) {
                    return ranges.some(range => date >= range.start && date <= range.end) 
                        ? [true, ''] 
                        : [false, ''];
                };
                optionsObj.minDate = start;
                optionsObj.maxDate = end;
            }
            return optionsObj;
        });
    }

    // Get today's date
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    // Calculate start and end dates based on plan type and user age
    const pageElement = document.getElementById('page');
    const userAge = parseInt(pageElement?.getAttribute('data-age'), 10);
    let startDate, endDate;

    if (pageElement?.classList.contains('age-specific-plans') && !isNaN(userAge)) {
        // Age-specific plans: start date is today's date minus 200 years
        startDate = `${month}/${day}/${year - (userAge + 1)}`;
    } else {
        // Non-age-specific: start date is today's date minus 65 years, end date is Jan 1 last year
        startDate = `${month}/${day}/${year - 65}`;
    }

    endDate = `01/01/${year - 1}`;

    // Apply date range to each datepicker
    document.querySelectorAll('.datepicker').forEach(input => {
        const inputID = input.id.split('_');
        const formId = inputID[1];
        const fieldId = inputID[2];
        setDateRange(formId, fieldId, startDate, endDate);
    });



    // Calculate the date for exactly 65 years ago from today
    const sixtyFiveYearsAgo = new Date();
    sixtyFiveYearsAgo.setFullYear(sixtyFiveYearsAgo.getFullYear() - 65);

    // Utility function to check if a date is before or the same as another date
    const isBeforeOrSame = (date1, date2) => date1 <= date2;

    // Select the Medicare dropdown and check if it exists
    const medicareDropdown = document.querySelector('.medicare-dropdown select');

    // Only add event listener if the Medicare dropdown and DOB input fields exist
    if (medicareDropdown) {
      document.querySelectorAll('.dob-field input').forEach(input => {
        input.addEventListener('change', (event) => {
          const dob = new Date(event.target.value); // Get the selected date

          // Check if DOB is before or equal to 65 years ago
          if (isBeforeOrSame(dob, sixtyFiveYearsAgo)) {
            medicareDropdown.value = 'true';
          } else {
            medicareDropdown.value = 'false';
          }
          
          // Trigger the change event for any listeners
          medicareDropdown.dispatchEvent(new Event('change'));
        });
      });
    }
}